// extracted by mini-css-extract-plugin
export var isPrintedCell = "_x4-1";
export var printerIcon = "_x4-0";